import * as React from 'react';
import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';

const DigitalTwinWidgetConfig = () => {
	return <Trans i18nKey="rafi.digitaltwin.nothingToConfigure">Nothing to configure</Trans>;
};

export default DigitalTwinWidgetConfig;
